/****************************************************
 * Module Name:  releaseStoneModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import { RiInboxUnarchiveLine } from "react-icons/ri";

const ReleaseStoneModal = ({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  customer,
  loading,
  data
}) => {
  const [remark, setRemark] = useState("");
  const [showError, setShowError] = useState(false);

  const saveHandler = () => {
    let tData = {
      userid: Constants.loggedInUser.id,
      // customerid: customer.value,
      customerid: customer,
      remark: remark,
      stones: data
    };
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(tData)) {
          handleSave(tData);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(tData);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <CommonSnackbar
        show={showError}
        message={
          <Box>
            Release Stone validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        enforceFocus={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Release Stone
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Remark</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Box sx={{
            "& .Mui-disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.12) !important",
              color: "rgba(0, 0, 0, 0.26) !important"
            }
          }}>
            <LoadingButton
              loading={loading}
              loadingPosition="start"
              startIcon={<RiInboxUnarchiveLine />}
              variant="contained"
              onClick={saveHandler}
              type="Submit"
              sx={{ mr: 3 }}
            >
              Release
            </LoadingButton>
          </Box>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReleaseStoneModal;
